webpackJsonp([1],{

/***/ "+Dbj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"m-t-70 page-services"},[_c('div',{staticClass:"page-headline m-b-30 m-t-70 align-center"},[_c('h1',{staticClass:"headline page-headline__title m-b-20"},[_vm._v(_vm._s(_vm.pageInfo.title))]),_vm._v(" "),_c('h4',{staticClass:"tagline page-headline__tagline",domProps:{"innerHTML":_vm._s(_vm.pageInfo.content)}})]),_vm._v(" "),_c('div',{staticClass:"section-services align-center"},[_c('div',{staticClass:"align-center"},[_c('div',{staticClass:"question m-b-30"},[_c('h1',{staticClass:"question__text"},[_c('strong',{staticClass:"question__number"},[_vm._v("01")]),_vm._v("\n          "+_vm._s(_vm.$t("services.softwareServicesTitle"))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},_vm._l((_vm.softwareSolutions),function(solution){return _c('div',{key:solution.id,staticClass:"col-xs-12 col-md-4 col-lg-4 solution"},[_c('div',{staticClass:"article has-shadow"},[_c('object',{ref:"mySVG",refInFor:true,attrs:{"id":solution.id,"type":"image/svg+xml","width":"75px","height":"150px","data":solution.image_url}}),_vm._v(" "),_c('div',{staticClass:"solution__desc"},[_c('h3',{staticClass:"headline section__header__headline"},[_vm._v(_vm._s(solution.title))]),_vm._v(" "),_c('p',{staticClass:"tagline section__header__tagline"},[_vm._v(_vm._s(solution.content))])])])])}))]),_vm._v(" "),_c('div',{staticClass:"align-center service-process"},[_c('h3',{staticClass:"aside--title"},[_vm._v(_vm._s(_vm.$t("services.softwareServicesProcessTitle")))]),_vm._v(" "),(this.$i18n.locale == 'en')?_c('img',{staticClass:"responsive-image",attrs:{"src":__webpack_require__("lxBQ"),"width":"700px","alt":""}}):_vm._e(),_vm._v(" "),(this.$i18n.locale == 'ar')?_c('img',{staticClass:"responsive-image",attrs:{"src":__webpack_require__("MZm1"),"width":"700px","alt":""}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"section-services align-center"},[_c('div',{staticClass:"align-center"},[_c('div',{staticClass:"question m-b-30"},[_c('h1',{staticClass:"question__text"},[_c('strong',{staticClass:"question__number"},[_vm._v("02")]),_vm._v("\n          "+_vm._s(_vm.$t("services.digitalServicesTitle"))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},_vm._l((_vm.marketingSolutions),function(solution){return _c('div',{key:solution.id,staticClass:"col-xs-12 col-md-4 col-lg-4 solution"},[_c('div',{staticClass:"article has-shadow"},[_c('object',{ref:"mySVG",refInFor:true,attrs:{"id":solution.id,"type":"image/svg+xml","width":"75px","height":"150px","data":solution.image_url}}),_vm._v(" "),_c('div',{staticClass:"solution__desc"},[_c('h3',{staticClass:"headline section__header__headline"},[_vm._v(_vm._s(solution.title))]),_vm._v(" "),_c('p',{staticClass:"tagline section__header__tagline"},[_vm._v(_vm._s(solution.content))])])])])}))]),_vm._v(" "),_c('div',{staticClass:"align-center service-process"},[_c('h3',{staticClass:"aside--title"},[_vm._v(_vm._s(_vm.$t("services.digitalServicesProcessTitle")))]),_vm._v(" "),(this.$i18n.locale == 'en')?_c('img',{staticClass:"responsive-image",attrs:{"src":__webpack_require__("lXxY"),"width":"900px","alt":""}}):_vm._e(),_vm._v(" "),(this.$i18n.locale == 'ar')?_c('img',{staticClass:"responsive-image",attrs:{"src":__webpack_require__("C27A"),"width":"900px","alt":""}}):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/oiM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_FetchService__ = __webpack_require__("GX/j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_ContactForm__ = __webpack_require__("0kTd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_google_maps__ = __webpack_require__("sA6N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_google_maps__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue2_google_maps__, {
  load: {
    key: "AIzaSyBgOjd2mnaHQAeNYHjipHIft5xF2gVVh2k"
  }
});

var fetchService = new __WEBPACK_IMPORTED_MODULE_0__services_FetchService__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Contact",
  data: function data() {
    return {
      pageTitle: "Loading...",
      pageInfo: {},
      contactUsContent: {},
      getAQuoteContent: {},
      jobsContent: {},
      companyProfile: {},
      companyLocation: {},
      contactAboutSection: {},
      contactProjectsSection: {}
    };
  },

  components: {
    ContactForm: __WEBPACK_IMPORTED_MODULE_1__modules_ContactForm__["a" /* default */]
  },
  metaInfo: function metaInfo() {
    return {
      title: this.pageTitle,
      meta: [{ itemprop: "name", content: this.pageInfo.meta_og_description }, { itemprop: "description", content: this.pageInfo.meta_og_description }, { name: "og:title", content: this.pageInfo.meta_og_title }, { name: "og:description", content: this.pageInfo.meta_og_description }, { name: "og:url", content: this.pageInfo.meta_url }, { name: "og:site_name", content: this.pageInfo.meta_twitter_site }, { name: "og:type", content: this.pageInfo.meta_og_type }, { name: "og:image", content: this.pageInfo.meta_og_image_url }, { name: "twitter:card", content: this.pageInfo.meta_twitter_card }, { name: "twitter:site", content: this.pageInfo.meta_twitter_site }, { name: "twitter:title", content: this.pageInfo.meta_twitter_title }, {
        name: "twitter:description",
        content: this.pageInfo.meta_twitter_description
      }, {
        name: "twitter:creator",
        content: this.pageInfo.meta_twitter_creator
      }, { name: "twitter:image", content: this.pageInfo.meta_twitter_image_url }]
    };
  },
  created: function created() {
    this.getPageInfo();
    this.getAll();
  },

  methods: {
    getPageInfo: function getPageInfo() {
      var _this = this;

      fetchService.getPageData(this.$parent.$parent.apiURL, 1).then(function (pageData) {
        _this.pageInfo = pageData.body;
        _this.pageTitle = _this.pageInfo.title;
      });
    },
    getAll: function getAll() {
      var _this2 = this;

      this.$http.get(this.$parent.$parent.apiURL + "/Companyprofiles").then(function (response) {
        this.companyProfile = response.body[0];
      });

      fetchService.getTextBlock(this.$parent.$parent.apiURL, "page-contact-us").then(function (response) {
        _this2.contactUsContent = response.body;
      });

      fetchService.getTextBlock(this.$parent.$parent.apiURL, "page-contact-us-get-quote").then(function (response) {
        _this2.getAQuoteContent = response.body;
      });

      fetchService.getTextBlock(this.$parent.$parent.apiURL, "page-contact-us-jobs").then(function (response) {
        _this2.jobsContent = response.body;
      });

      fetchService.getTextBlock(this.$parent.$parent.apiURL, "page-contact-us-about").then(function (response) {
        _this2.contactAboutSection = response.body;
      });

      fetchService.getTextBlock(this.$parent.$parent.apiURL, "page-contact-us-projects").then(function (response) {
        _this2.contactProjectsSection = response.body;
      });
    }
  }
});

/***/ }),

/***/ "/yRs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__ = __webpack_require__("diQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2a2679ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__("nmO7");
function injectStyle (ssrContext) {
  __webpack_require__("IWEu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2a2679ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0kTd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactForm_vue__ = __webpack_require__("AH1C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00ab50e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactForm_vue__ = __webpack_require__("XgTB");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00ab50e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1Xeb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"m-t-70"},[_c('div',{staticClass:"page-headline m-b-30 m-t-70 align-center"},[_c('h1',{staticClass:"headline page-headline__title m-b-20"},[_vm._v(_vm._s(_vm.pageInfo.title))]),_vm._v(" "),_c('h4',{staticClass:"tagline page-headline__tagline",domProps:{"innerHTML":_vm._s(_vm.pageInfo.content)}})]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row top-md"},_vm._l((_vm.news),function(blog){return _c('article',{key:blog.id,staticClass:"col-lg-6 col-md-6 col-sm-12 col-xs-12"},[_c('div',{staticClass:"article has-shadow"},[(blog.source_url == '')?_c('router-link',{attrs:{"to":{ path: 'blog/' + blog.slug , params: { lang: _vm.$parent.$parent.$i18n.locale }}}},[_c('div',{staticClass:"article__image",style:({ backgroundImage: 'url(' + blog.feature_image_url + ')' })})]):_c('a',{attrs:{"target":"_blank","rel":"noopener","href":blog.source_url}},[_c('div',{staticClass:"article__image",style:({ backgroundImage: 'url(' + blog.feature_image_url + ')' })})]),_vm._v(" "),_c('div',{staticClass:"article__content"},[(blog.author)?_c('span',{staticClass:"article__content__source"},[_vm._v("\n                        "+_vm._s(blog.author.name)+"\n                      ")]):_c('span',{staticClass:"article__content__source"},[(blog.source_image_url != '')?_c('img',{staticClass:"responsive-image",attrs:{"src":blog.source_image_url,"alt":blog.source_name,"width":"100px"}}):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"article__content__date m-t-10"},[_vm._v(_vm._s(blog.date))]),_vm._v(" "),_c('h1',{staticClass:"article__content__headline m-t-20 m-b-10"},[(blog.source_url == '')?_c('router-link',{attrs:{"to":{ path: 'blog/' + blog.slug , params: { lang: _vm.$parent.$parent.$i18n.locale }}}},[_vm._v("\n                            "+_vm._s(blog.title)+"\n                        ")]):_c('a',{attrs:{"target":"_blank","rel":"noopener","href":blog.source_url}},[_vm._v("\n                            "+_vm._s(blog.title)+"\n                        ")])],1),_vm._v(" "),_c('p',{staticClass:"article__content__summary",domProps:{"innerHTML":_vm._s(blog.summary)}}),_vm._v(" "),(blog.source_url == '')?_c('router-link',{staticClass:"button button--link button--link--peach m-t-20",attrs:{"to":{ path: 'blog/' + blog.slug , params: { lang: _vm.$parent.$parent.$i18n.locale }}}},[_c('span',{staticClass:"button--link__text button--link--peach__text"},[_vm._v(_vm._s(_vm.$t("global.readAboutThis")))])]):_vm._e(),_vm._v(" "),(blog.source_url != '')?_c('a',{staticClass:"button button--link button--link--peach m-t-20",attrs:{"target":"_blank","rel":"noopener","href":blog.source_url}},[_c('span',{staticClass:"button--link__text button--link--peach__text"},[_vm._v(_vm._s(_vm.$t("global.readAboutThis")))])]):_vm._e()],1)],1)])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3DAb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vivus__ = __webpack_require__("Jn6l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vivus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vivus__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype, "$Vivus", { value: __WEBPACK_IMPORTED_MODULE_1_vivus___default.a });

/* harmony default export */ __webpack_exports__["a"] = ({
	name: "Skills",
	data: function data() {
		return {
			sectionPlansContent: {},
			plans: []
		};
	},
	mounted: function mounted() {
		this.getAll();
	},

	methods: {
		getAll: function getAll() {
			this.$http.get(this.$parent.$parent.$parent.apiURL + "/textblocks?filter[name]=homepage-section-plans-content").then(function (response) {
				this.sectionPlansContent = response.body;
			});

			this.$http.get(this.$parent.$parent.$parent.apiURL + "/textblocks/text-blocks-widgets?filter[name]=homepage-section-plans").then(function (response) {
				this.plans = response.body.widget_blocks;
			});
		}
	}
});

/***/ }),

/***/ "3MQM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_v_tooltip__ = __webpack_require__("VN6J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_localstorage__ = __webpack_require__("UnSZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_localstorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_localstorage__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_v_tooltip__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_localstorage___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
	name: "MainHeader",
	props: ["preLoading"],
	data: function data() {
		return {
			toArabic: "العربية",
			toEnglish: "English",
			isVisibleMegaMenu: false
		};
	},

	methods: {
		toggleMegaMenu: function toggleMegaMenu(event) {
			this.isVisibleMegaMenu = !this.isVisibleMegaMenu;
		},
		closeMenu: function closeMenu() {
			this.isVisibleMegaMenu = false;
		},
		setLanguage: function setLanguage(lang) {
			this.$emit("update:preLoading", true);
			__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].localStorage.set("userLang", lang);
			this.$route.params.lang = lang;
			this.$i18n.locale = lang;
			this.$validator.locale = lang;
			this.$validator.localize(lang);
			this.$router.push({ force: true, name: this.$route.name, params: { lang: lang } }, function () {
				location.reload();
			});
		}
	}
});

/***/ }),

/***/ "3ykt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid has-shadow"},[_c('div',{staticClass:"row footer__top"},[_c('div',{staticClass:"col-lg-3 col-md-3 col-sm-6 col-xs-12 m-b-20-xs"},[_c('img',{staticClass:"responsive-image",attrs:{"src":_vm.companyProfile.logo_url,"width":"200","alt":""}}),_vm._v(" "),_c('p',{staticClass:"footer__top__section-tagline"},[_vm._v(_vm._s(_vm.companyProfile.bio))]),_vm._v(" "),_c('h6',{staticClass:"footer__top__section-headline"},[_vm._v("\n        "+_vm._s(_vm.$t("footer.keepTouch"))+"\n      ")]),_vm._v(" "),(_vm.companyProfile.twitter_profile != '')?_c('a',{staticClass:"icon-link",attrs:{"target":"_blank","rel":"noopener","href":_vm.companyProfile.twitter_profile}},[_c('i',{staticClass:"fa fa-twitter fa-2x",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.companyProfile.linkedin_profile != '')?_c('a',{staticClass:"icon-link",attrs:{"target":"_blank","rel":"noopener","href":_vm.companyProfile.linkedin_profile}},[_c('i',{staticClass:"fa fa-linkedin fa-2x",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.companyProfile.facebook_profile != '')?_c('a',{staticClass:"icon-link",attrs:{"target":"_blank","rel":"noopener","href":_vm.companyProfile.facebook_profile}},[_c('i',{staticClass:"fa fa-facebook-f fa-2x",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.companyProfile.youtube_profile != '')?_c('a',{staticClass:"icon-link",attrs:{"target":"_blank","rel":"noopener","href":_vm.companyProfile.youtube_profile}},[_c('i',{staticClass:"fa fa-youtube fa-2x",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.companyProfile.instagram_profile != '')?_c('a',{staticClass:"icon-link",attrs:{"target":"_blank","rel":"noopener","href":_vm.companyProfile.instagram_profile}},[_c('i',{staticClass:"fa fa-instagram fa-2x",attrs:{"aria-hidden":"true"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-md-3 col-sm-6 hidden-xs"},[_c('ul',[_c('li',[_c('h6',{staticClass:"footer__top__section-headline"},[_vm._v(_vm._s(_vm.footerMenu_1.title))])]),_vm._v(" "),_vm._l((_vm.footerMenu_1.options),function(menuItem){return _c('li',{key:menuItem.id},[_c('router-link',{attrs:{"to":{ path: '/' + _vm.$parent.$parent.$i18n.locale + menuItem.url }}},[_vm._v("\n              "+_vm._s(menuItem.title)+"\n            ")])],1)})],2)]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-md-3 col-sm-6 hidden-xs"},[_c('ul',[_c('li',[_c('h6',{staticClass:"footer__top__section-headline"},[_vm._v(_vm._s(_vm.$t("menu.blog")))])]),_vm._v(" "),_vm._l((_vm.news.slice(0, 3)),function(blog){return _c('li',{key:blog.id},[(blog.source_url == '')?_c('router-link',{attrs:{"to":{ path: '/' + _vm.$parent.$parent.$i18n.locale + '/blog/' + blog.slug }}},[_vm._v("\n              "+_vm._s(blog.title)+"\n            ")]):_vm._e(),_vm._v(" "),(blog.source_url != '')?_c('a',{attrs:{"target":"_blank","rel":"noopener","href":blog.source_url}},[_vm._v("\n              "+_vm._s(blog.title)+"\n            ")]):_vm._e()],1)})],2)]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-md-3 col-sm-6 col-xs-12"},[_c('ul',[_c('li',[_c('h6',{staticClass:"footer__top__section-headline"},[_vm._v(_vm._s(_vm.$t("menu.contactUs")))])]),_vm._v(" "),_c('li',[_c('p',{staticClass:"footer__top__section-tagline"},[_vm._v(_vm._s(_vm.companyProfile.address))])]),_vm._v(" "),_c('li',{staticStyle:{"unicode-bidi":"plaintext"}},[_vm._v(_vm._s(_vm.companyProfile.phone_number_1))]),_vm._v(" "),_c('li',[_c('a',{staticClass:"button button--link button--link--peach",attrs:{"target":"_blank","rel":"noopener","href":'mailto:' + _vm.companyProfile.email}},[_c('span',{staticClass:"button--link__text button--link--peach__text"},[_vm._v(_vm._s(_vm.companyProfile.email))])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4xqg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5ZbH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__ = __webpack_require__("kXiA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b469fcc4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__("GllG");
function injectStyle (ssrContext) {
  __webpack_require__("L8C9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b469fcc4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5cLx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__ = __webpack_require__("Vj7G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1dcbea28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__("CO71");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1dcbea28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5yYN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Privacy",
  data: function data() {
    return {
      pageTitle: "Loading...",
      pageInfo: {}
    };
  },
  metaInfo: function metaInfo() {
    return {
      title: this.pageTitle,
      meta: [{ itemprop: "name", content: this.pageInfo.meta_og_description }, { itemprop: "description", content: this.pageInfo.meta_og_description }, { name: "og:title", content: this.pageInfo.meta_og_title }, { name: "og:description", content: this.pageInfo.meta_og_description }, { name: "og:url", content: this.pageInfo.meta_url }, { name: "og:site_name", content: this.pageInfo.meta_twitter_site }, { name: "og:type", content: this.pageInfo.meta_og_type }, { name: "og:image", content: this.pageInfo.meta_og_image_url }, { name: "twitter:card", content: this.pageInfo.meta_twitter_card }, { name: "twitter:site", content: this.pageInfo.meta_twitter_site }, { name: "twitter:title", content: this.pageInfo.meta_twitter_title }, {
        name: "twitter:description",
        content: this.pageInfo.meta_twitter_description
      }, {
        name: "twitter:creator",
        content: this.pageInfo.meta_twitter_creator
      }, { name: "twitter:image", content: this.pageInfo.meta_twitter_image_url }]
    };
  },
  created: function created() {
    this.getPageInfo();
  },

  methods: {
    getPageInfo: function getPageInfo() {
      this.$http.get(this.$parent.$parent.apiURL + "/Pages?id=2").then(function (response) {
        this.pageInfo = response.body;
        this.pageTitle = this.pageInfo.title;
      });
    }
  }
});

/***/ }),

/***/ "64hC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section section-concepts has-shadow"},[_c('div',{staticClass:"section-concepts--title"},[_c('h2',[_vm._v(_vm._s(_vm.$t("global.targetedClients")))])]),_vm._v(" "),_c('vue-tabs',{attrs:{"active-tab-color":"#f4f4f4","type":"pills","start-index":1,"direction":"vertical"}},_vm._l((_vm.whatWeDo),function(task){return _c('v-tab',{key:task.id},[_c('div',{staticClass:"tab-title",attrs:{"slot":"title"},slot:"title"},[_c('img',{attrs:{"src":task.sub_title}}),_vm._v(" "),_c('strong',{staticClass:"title title_center"},[_vm._v(_vm._s(task.title))])]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"row tab-content__row"},[_c('div',{staticClass:"col-md-6 col-md-offset-1 col-sm-6 col-sm-offset-1 col-xs-12 tab-content__desc"},[_c('h2',{staticClass:"headline tab-content__desc__headline"},[_vm._v(_vm._s(task.title))]),_vm._v(" "),_c('p',{staticClass:"tagline tab-content__desc__tagline"},[_vm._v(_vm._s(task.content))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-md-offset-1 col-sm-5 col-xs-12 col-xs-offset-0 tab-content__image"},[_c('object',{attrs:{"id":task.id,"type":"image/svg+xml","width":"200px","data":task.image_url}})])])])])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6aPd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "74w9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"page-headline m-b-30 m-t-70 align-center"},[_c('h1',{staticClass:"headline page-headline__title m-b-20"},[_vm._v(_vm._s(_vm.pageInfo.title))]),_vm._v(" "),_c('h4',{staticClass:"tagline page-headline__tagline",domProps:{"innerHTML":_vm._s(_vm.pageInfo.content)}})]),_vm._v(" "),_c('div',{staticClass:"align-center estimation"},[_c('div',{staticClass:"container"},[_c('p',[_vm._v("\n        "+_vm._s(_vm.$t("global.projectEstimation"))+"\n        "),_c('strong',[_vm._v(_vm._s(_vm.projectEstimation)+" USD")])])])]),_vm._v(" "),_c('div',{staticClass:"container"},[_vm._l((_vm.surveyQuestions),function(question){return (!_vm.showForm)?_c('div',{key:question.id,staticClass:"question-wrapper"},[_c('div',{staticClass:"question m-b-30 align-center"},[_c('h1',{staticClass:"question__text"},[_c('strong',{staticClass:"question__number"},[_vm._v("\n            0"+_vm._s(_vm.questionNumber)+"\n          ")]),_vm._v("\n          "+_vm._s(question.title)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"answer center-md center-xs row m-b-30"},_vm._l((question.options),function(option){return _c('div',{key:option.id,staticClass:"col-md-2 col-sm-4 col-xs-12"},[_c('div',{staticClass:"align-center answer__option"},[_c('label',[(_vm.showGoNext)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedOptions),expression:"checkedOptions"}],attrs:{"type":"checkbox","name":question.id,"question":question.id,"selectedOptionValue":option.value},domProps:{"value":option.id,"checked":_vm.isChecked,"checked":Array.isArray(_vm.checkedOptions)?_vm._i(_vm.checkedOptions,option.id)>-1:(_vm.checkedOptions)},on:{"change":[function($event){var $$a=_vm.checkedOptions,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=option.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkedOptions=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkedOptions=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checkedOptions=$$c}},function($event){_vm.optionCheckboxSelected($event, option, question.id)}]}}):_c('input',{attrs:{"type":"radio","name":question.id,"question":question.id},domProps:{"value":option.id,"checked":_vm.isChecked},on:{"change":function($event){_vm.optionSelected(option, question.id)}}}),_vm._v(" "),_c('div',{staticClass:"box"},[_c('object',{staticClass:"answer__option__image",attrs:{"slot":"image","id":option.id,"type":"image/svg+xml","data":option.image_url},slot:"image"}),_vm._v(" "),_c('h1',{staticClass:"answer__option__text m-t-10 m-b-30"},[_vm._v(_vm._s(option.title))]),_vm._v(" "),_c('span',{staticClass:"circle"})])])])])})),_vm._v(" "),_c('div',{staticClass:"row center-md between-md center-xs around-xs m-b-30"},[(_vm.showGoBack)?_c('a',{staticClass:"button button--primary button--primary__small",on:{"click":function($event){$event.preventDefault();_vm.goBack()}}},[_c('span',{staticClass:"button--primary__text"},[_vm._v(_vm._s(_vm.$t("global.goBack")))])]):_vm._e(),_vm._v(" "),(_vm.showGoNext)?_c('button',{staticClass:"button button--primary button--primary__small",attrs:{"disabled":_vm.goNextIsDisabled},on:{"click":function($event){$event.preventDefault();_vm.goNext()}}},[_c('span',{staticClass:"button--primary__text"},[_vm._v(_vm._s(_vm.$t("global.goNext")))])]):_vm._e()])]):_vm._e()}),_vm._v(" "),(_vm.showForm)?_c('div',{staticClass:"row center-md center-xs contact-form-container pricing-form m-t-30"},[_c('Contact-Form',{attrs:{"form-name":"get-an-estimation","project-estimation":_vm.projectEstimation,"start-time":_vm.startTime,"user-selected-options":_vm.mylist}})],1):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7COe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopFooter_vue__ = __webpack_require__("pwH5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a969b5a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopFooter_vue__ = __webpack_require__("3ykt");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a969b5a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8Tel":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/softcare-logo-ar.50b8cd7.png";

/***/ }),

/***/ "8mQd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Privacy_vue__ = __webpack_require__("5yYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9081bad0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Privacy_vue__ = __webpack_require__("ZCdO");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Privacy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9081bad0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Privacy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9Tyx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__("TXmL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_localstorage__ = __webpack_require__("UnSZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_localstorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_localstorage__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_localstorage___default.a);

var messages = {
	en: {
		websiteName: "SoftCare",
		footer: {
			keepTouch: "Keep in touch"
		},
		global: {
			startNewProject: "Start your project",
			readAboutThis: "Read about this",
			checkOurProjects: "Check our projects",
			getAQoute: "Get A Quote",
			carrers: "Carrers",
			stayInTouch: "Stay in touch with us through social networks",
			projectEstimation: "Your project estimation is around: ",
			getAnEstimation: "Get an estimation",
			becomeAClient: "Become one of our clients",
			goBack: "Go Back",
			goNext: "Go Next",
			share: "Share:",
			facebook: "Facebook",
			linkedIn: "LinkedIn",
			twitter: "Twitter",
			by: "By:",
			targetedClients: "We work passionately with",
			companyProfile: "Download Company Profile"
		},
		project: {
			projectType: "Project type",
			clientName: "Client name",
			liveVersion: "Check live version"
		},
		menu: {
			aboutUs: "About Us",
			blog: "Blog",
			contactUs: "Contact Us",
			projects: "Projects",
			services: "Services"
		},
		form: {
			fullName: "Full Name",
			emailAddress: "Email Address",
			yourReferal: "How did you hear about us?",
			message: "Message",
			sendYourMessage: "Send your message",
			messageSendingError: "We can't send your message right now, please try again later.",
			messageSendingSuccess: "We will be glad to answer all your queries and get in touch with you. We will reply to you as soon as we can."
		},
		referal: {
			google: "Google Search",
			social: "Social Media: Twitter, LinkedIn",
			friend: "A Friend",
			other: "Other"
		},
		services: {
			softwareServicesTitle: "Software Solutions",
			digitalServicesTitle: "Digital Marketing",
			softwareServicesProcessTitle: "The Lego Method",
			digitalServicesProcessTitle: "Digital Marketing Process"
		}
	},
	ar: {
		websiteName: "سوفت كير",
		footer: {
			keepTouch: "كن على تواصل"
		},
		global: {
			startNewProject: "ابدأ مشروعك الآن",
			readAboutThis: "اقرأ المزيد",
			checkOurProjects: "شاهد معرض أعمالنا",
			getAQoute: "احصل على عرض سعر",
			carrers: "الوظائف",
			stayInTouch: "كن على تواصل معنا عن طريق مواقع التواصل الإجتماعي",
			projectEstimation: "تكلفة مشروعك تبدأ قيمتها من: ",
			getAnEstimation: "احصل على عرض سعر",
			becomeAClient: "انضم لتصبح أحد عملائنا",
			goBack: "العودة",
			goNext: "التالي",
			share: "مشاركة:",
			facebook: "فيسبوك",
			linkedIn: "لينكدإن",
			twitter: "تويتر",
			by: "بواسطة:",
			targetedClients: "نعمل بشغف مع",
			companyProfile: "تحميل الملف التعريفي"
		},
		project: {
			projectType: "نوع المشروع",
			clientName: "العميل المنفذ له العمل",
			liveVersion: "شاهد النسخة الحية"
		},
		menu: {
			aboutUs: "عن سوفت كير",
			blog: "المدونة",
			contactUs: "اتصل بنا",
			projects: "أعمالنا",
			services: "خدماتنا"
		},
		form: {
			fullName: "الإسم بالكامل",
			emailAddress: "البريد الإلكتروني",
			yourReferal: "كيف تعرفت على سوفت كير؟",
			message: "نص الرسالة",
			sendYourMessage: "إرسال",
			messageSendingError: "تعذر إرسال رسالتك فضلاً أعد المحاولة بعد قليل.",
			messageSendingSuccess: "نسعد بالتواصل معك والإجابة على كافة الاستفسارات. سنقوم بالرد عليك في أقرب وقت ممكن."
		},
		referal: {
			google: "محرك بحث جوجل",
			social: "مواقع التواصل الإجتماعي: تويتر - لينكدإن",
			friend: "عن طريق صديق",
			other: "أخرى"
		},
		services: {
			softwareServicesTitle: "الحلول البرمجية",
			digitalServicesTitle: "التسويق الرقمي",
			softwareServicesProcessTitle: "أسلوب الليقو",
			digitalServicesProcessTitle: "مراحل التسويق الرقمي"
		}
	}
};

var hrefLang = "";
// let url = 'http://softcare.io/en'
// console.log(url)
// console.log(url.match('\\/ar|/en'))

// // console.log(window.location.href)
// // console.log(window.location.href.match('\\ar|en'))
if (window.location.href.match("\\/ar|/en")) {
	var match = window.location.href.match("\\/ar|/en")[0];
	if (match === "/en") {
		hrefLang = "en";
	} else {
		hrefLang = "ar";
	}
	__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].localStorage.set("userLang", hrefLang);
}
// console.log(hrefLang)
// console.log(Vue.localStorage.get('userLang'))

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
	messages: messages,
	locale: hrefLang || __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].localStorage.get("userLang") || "ar"
}));

/***/ }),

/***/ "AH1C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_materialize_css__ = __webpack_require__("0lrd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_materialize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vee_validate_dist_locale_ar__ = __webpack_require__("VyJT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vee_validate_dist_locale_ar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vee_validate_dist_locale_ar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate_dist_locale_en__ = __webpack_require__("q4V8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate_dist_locale_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vee_validate_dist_locale_en__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype, "$materialize", { value: __WEBPACK_IMPORTED_MODULE_2_materialize_css___default.a });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ContactForm",
  props: ["FormName", "ProjectEstimation", "ReferalSource", "StartTime", "UserSelectedOptions"],
  data: function data() {
    return {
      estimationForm: false,
      contactMessageRequest: false,
      messageSendingError: false,
      messageSendingSuccess: false,
      disabledForm: true,
      endTime: 0,
      referalSource: "",
      ContactUsForm: {
        message: {
          fullName: "",
          email: "",
          messageContent: ""
        }
      }
    };
  },
  mounted: function mounted() {
    if (this.FormName === "get-an-estimation") {
      this.estimationForm = true;
    }
    if (this.$i18n.locale === "ar") {
      this.$validator.localize("ar", {
        messages: __WEBPACK_IMPORTED_MODULE_3_vee_validate_dist_locale_ar___default.a.messages,
        attributes: {
          fullName: "الاسم بالكامل",
          email: "البريد الالكتروني",
          referal: "المصدر",
          message: "نص الرسالة"
        }
      });
    } else {
      this.$validator.localize("en", {
        messages: __WEBPACK_IMPORTED_MODULE_4_vee_validate_dist_locale_en___default.a.messages
      });
    }
  },

  methods: {
    millisToMinutesAndSeconds: function millisToMinutesAndSeconds(millis) {
      var minutes = Math.floor(millis / 60000);
      var seconds = (millis % 60000 / 1000).toFixed(0);
      return minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
    },
    validateBeforeSubmit: function validateBeforeSubmit(message) {
      var _self = this;
      this.$validator.validateAll().then(function (result) {
        if (result) {
          _self.sendMessage(message);
        }
      });
    },
    sendMessage: function sendMessage(message) {
      this.contactMessageRequest = true;
      var url = this.$parent.$parent.$parent.apiURL + "/contactuses/submit";
      var _self = this;

      if (this.estimationForm) {
        var endTime = new Date();
        var timeToFinish = endTime - this.StartTime;
        var timeSpent = this.millisToMinutesAndSeconds(timeToFinish);
        var selectedOptions = "";

        this.UserSelectedOptions.forEach(function (option) {
          var selectedOptionsTitle = "";
          option.selectedOptionTitle.forEach(function (title) {
            selectedOptionsTitle += title + ", ";
          });
          selectedOptions += option.question + " : " + selectedOptionsTitle;
        });
        message["userSelectedOptions"] = selectedOptions;
        message["timeSpent"] = timeSpent;
        message["projectEstimation"] = _self.ProjectEstimation;
      }
      message["referalSource"] = this.referalSource;

      this.$http.post(url, { name: this.FormName, data: message }).then(function (response) {
        this.contactMessageRequest = false;
        this.messageSendingError = false;
        this.messageSendingSuccess = true;
      }, function (error) {
        this.messageSendingError = true;
        this.messageSendingSuccess = false;
        this.contactMessageRequest = false;
      });
    }
  }
});

/***/ }),

/***/ "Bmoy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"m-t-70"},[_c('div',{staticClass:"page-headline m-b-30 m-t-70 align-center"},[_c('h1',{staticClass:"headline page-headline__title m-b-20"},[_vm._v(_vm._s(_vm.pageInfo.title))]),_vm._v(" "),_c('h4',{staticClass:"tagline page-headline__tagline",domProps:{"innerHTML":_vm._s(_vm.pageInfo.content)}})]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('Contact-Form',{attrs:{"form-name":"contact-us"}}),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-md-offset-1 center-md col-xs-12 center-xs"},[_c('div',{staticClass:"m-b-30"},[_c('img',{staticClass:"m-b-20 responsive-image",attrs:{"src":__webpack_require__("eDj8"),"width":"75px","alt":""}}),_vm._v(" "),_c('p',{staticClass:"condensed"},[_vm._v("\n                        "+_vm._s(_vm.getAQuoteContent.content)+"\n                        "),_c('router-link',{staticClass:"button\n                        button--link button--link--peach m-t-20",attrs:{"to":{ name: 'pricing', params: { lang: _vm.$parent.$parent.$i18n.locale }}}},[_c('span',{staticClass:"button--link__text button--link--peach__text"},[_vm._v(_vm._s(_vm.$t("global.getAQoute")))])])],1)]),_vm._v(" "),_c('div',{staticClass:"m-b-30"},[_c('p',{staticClass:"tagline"},[_vm._v(_vm._s(_vm.$t("global.stayInTouch")))]),_vm._v(" "),(_vm.companyProfile.twitter_profile != '')?_c('a',{staticClass:"icon-link",attrs:{"target":"_blank","rel":"noopener","href":_vm.companyProfile.twitter_profile}},[_c('i',{staticClass:"fa fa-twitter fa-2x",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.companyProfile.linkedin_profile != '')?_c('a',{staticClass:"icon-link",attrs:{"target":"_blank","rel":"noopener","href":_vm.companyProfile.linkedin_profile}},[_c('i',{staticClass:"fa fa-linkedin fa-2x",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.companyProfile.facebook_profile != '')?_c('a',{staticClass:"icon-link",attrs:{"target":"_blank","rel":"noopener","href":_vm.companyProfile.facebook_profile}},[_c('i',{staticClass:"fa fa-facebook-f fa-2x",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.companyProfile.youtube_profile != '')?_c('a',{staticClass:"icon-link",attrs:{"target":"_blank","rel":"noopener","href":_vm.companyProfile.youtube_profile}},[_c('i',{staticClass:"fa fa-youtube fa-2x",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.companyProfile.instagram_profile != '')?_c('a',{staticClass:"icon-link",attrs:{"target":"_blank","rel":"noopener","href":_vm.companyProfile.instagram_profile}},[_c('i',{staticClass:"fa fa-instagram fa-2x",attrs:{"aria-hidden":"true"}})]):_vm._e()])])],1)]),_vm._v(" "),_c('div',{staticClass:"m-t-30 m-b-30"},[_c('gmap-map',{staticStyle:{"width":"100%","height":"300px"},attrs:{"center":{lat:21.324394, lng:39.959314},"zoom":14}},[_c('gmap-marker',{attrs:{"position":{lat:21.324394, lng:39.959314},"clickable":true}})],1)],1),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-xs-12 center-xs"},[_c('span',{staticClass:"tag"},[_vm._v(_vm._s(_vm.contactAboutSection.sub_title))]),_vm._v(" "),_c('h1',{staticClass:"headline m-b-30 m-t-10"},[_vm._v(_vm._s(_vm.contactAboutSection.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.contactAboutSection.content))]),_vm._v(" "),_c('router-link',{staticClass:"button button--link button--link--peach m-t-20",attrs:{"to":{ name: 'about', params: { lang: _vm.$parent.$parent.$i18n.locale }}}},[_c('span',{staticClass:"button--link__text button--link--peach__text"},[_vm._v("\n                    "+_vm._s(_vm.$t("global.readAboutThis"))+"\n                  ")])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-md-offset-4 col-xs-12 center-xs"},[_c('span',{staticClass:"tag"},[_vm._v(_vm._s(_vm.contactProjectsSection.sub_title))]),_vm._v(" "),_c('h1',{staticClass:"headline m-b-30 m-t-10"},[_vm._v(_vm._s(_vm.contactProjectsSection.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.contactProjectsSection.content))]),_vm._v(" "),_c('router-link',{staticClass:"button button--link button--link--peach m-t-20",attrs:{"to":{ name: 'projects', params: { lang: _vm.$parent.$parent.$i18n.locale }}}},[_c('span',{staticClass:"button--link__text button--link--peach__text"},[_vm._v("\n                    "+_vm._s(_vm.$t("global.readAboutThis"))+"\n                  ")])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BrpM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C27A":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/marketing-services-steps-ar.059a1da.png";

/***/ }),

/***/ "CHQz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: "Blog",
	data: function data() {
		return {
			pageTitle: "Loading...",
			pageInfo: {},
			news: []
		};
	},
	metaInfo: function metaInfo() {
		return {
			title: this.pageTitle,
			meta: [{ itemprop: "name", content: this.pageInfo.meta_og_description }, { itemprop: "description", content: this.pageInfo.meta_og_description }, { name: "og:title", content: this.pageInfo.meta_og_title }, { name: "og:description", content: this.pageInfo.meta_og_description }, { name: "og:url", content: this.pageInfo.meta_url }, { name: "og:site_name", content: this.pageInfo.meta_twitter_site }, { name: "og:type", content: this.pageInfo.meta_og_type }, { name: "og:image", content: this.pageInfo.meta_og_image_url }, { name: "twitter:card", content: this.pageInfo.meta_twitter_card }, { name: "twitter:site", content: this.pageInfo.meta_twitter_site }, { name: "twitter:title", content: this.pageInfo.meta_twitter_title }, {
				name: "twitter:description",
				content: this.pageInfo.meta_twitter_description
			}, {
				name: "twitter:creator",
				content: this.pageInfo.meta_twitter_creator
			}, { name: "twitter:image", content: this.pageInfo.meta_twitter_image_url }]
		};
	},
	created: function created() {
		this.getAll();
		this.getPageInfo();
	},

	methods: {
		getPageInfo: function getPageInfo() {
			this.$http.get(this.$parent.$parent.apiURL + "/Pages?id=4").then(function (response) {
				this.pageInfo = response.body;
				this.pageTitle = this.pageInfo.title;
			});
		},
		getAll: function getAll() {
			this.$http.get(this.$parent.$parent.apiURL + "/news").then(function (response) {
				this.news = response.body;
			});
		}
	}
});

/***/ }),

/***/ "CO71":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FhpU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_social_sharing__ = __webpack_require__("VK1f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_social_sharing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_social_sharing__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_social_sharing___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
	name: "BlogDetails",
	data: function data() {
		return {
			pageTitle: "Loading...",
			pageInfo: {},
			params: this.$route.params.slug,
			pageUrl: location.href
		};
	},
	metaInfo: function metaInfo() {
		return {
			title: this.pageTitle,
			meta: [{ itemprop: "name", content: this.pageInfo.meta_og_description }, { itemprop: "description", content: this.pageInfo.meta_og_description }, { name: "og:title", content: this.pageInfo.meta_og_title }, { name: "og:description", content: this.pageInfo.meta_og_description }, { name: "og:url", content: this.pageInfo.meta_url }, { name: "og:site_name", content: this.pageInfo.meta_twitter_site }, { name: "og:type", content: this.pageInfo.meta_og_type }, { name: "og:image", content: this.pageInfo.meta_og_image_url }, { name: "twitter:card", content: this.pageInfo.meta_twitter_card }, { name: "twitter:site", content: this.pageInfo.meta_twitter_site }, { name: "twitter:title", content: this.pageInfo.meta_twitter_title }, {
				name: "twitter:description",
				content: this.pageInfo.meta_twitter_description
			}, {
				name: "twitter:creator",
				content: this.pageInfo.meta_twitter_creator
			}, { name: "twitter:image", content: this.pageInfo.meta_twitter_image_url }]
		};
	},
	created: function created() {
		this.getContent();
	},

	methods: {
		getContent: function getContent() {
			this.$http.get(this.$parent.$parent.apiURL + "/news?filter[slug]=" + this.params).then(function (response) {
				this.pageInfo = response.body;
				this.pageTitle = this.pageInfo.title;
			});
		}
	}
});

/***/ }),

/***/ "FnhZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__("/oiM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60931730_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__("Bmoy");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60931730_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "G/Ls":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"banner"},[_c('div',{staticClass:"banner__content"},[(this.$i18n.locale == 'en')?_c('img',{staticClass:"responsive-image",attrs:{"src":__webpack_require__("lxBQ"),"width":"700px","alt":""}}):_vm._e(),_vm._v(" "),(this.$i18n.locale == 'ar')?_c('img',{staticClass:"responsive-image",attrs:{"src":__webpack_require__("MZm1"),"width":"700px","alt":""}}):_vm._e(),_vm._v(" "),_c('h1',{staticClass:"headline banner__content-headline"},[_vm._v(_vm._s(_vm.bannerContent.title))]),_vm._v(" "),_c('p',{staticClass:"tagline banner__content-desc"},[_vm._v(_vm._s(_vm.bannerContent.content))]),_vm._v(" "),_c('router-link',{staticClass:"button button--primary",attrs:{"to":{ path: this.$i18n.locale + _vm.bannerContent.url }}},[_c('span',{staticClass:"button--primary__text"},[_vm._v(_vm._s(_vm.$t("global.startNewProject")))])])],1)]),_vm._v(" "),_c('Skills'),_vm._v(" "),_c('div',{staticClass:"section section-projects align-center",style:({ backgroundImage: 'url(' + _vm.sectionProjectContent.image_url + ')' })},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 col-md-offset-7 col-sm-7 col-sm-offset-5 col-xs-12"},[_c('div',{staticClass:"section__header m-t-30"},[_c('h1',{staticClass:"headline section__header__headline headline-number"},[_vm._v(_vm._s(_vm.totalNumberOfProjects))]),_vm._v(" "),_c('h1',{staticClass:"headline section__header__headline"},[_vm._v(_vm._s(_vm.sectionProjectContent.sub_title))]),_vm._v(" "),_c('p',{staticClass:"tagline section__header__tagline"},[_vm._v(_vm._s(_vm.sectionProjectContent.content))]),_vm._v(" "),_c('router-link',{staticClass:"button button--primary",attrs:{"to":{ path: this.$i18n.locale + _vm.sectionProjectContent.url }}},[_c('span',{staticClass:"button--primary__text"},[_vm._v(_vm._s(_vm.$t("global.checkOurProjects")))])])],1)])])])]),_vm._v(" "),_c('Plans'),_vm._v(" "),_c('Clients')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "G674":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GPmT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-wrapper"},[_c('div',{staticClass:"preview-area"},[_c('div',{staticClass:"sk-double-bounce"},[_c('div',{staticClass:"sk-child sk-double-bounce1"}),_vm._v(" "),_c('div',{staticClass:"sk-child sk-double-bounce2"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GX/j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");




var FetchService = function () {
	function FetchService() {
		__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, FetchService);
	}

	__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(FetchService, [{
		key: "getPageData",
		value: function getPageData(APIUrl, pageID) {
			return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.get(APIUrl + "/Pages?id=" + pageID);
		}
	}, {
		key: "getTextBlock",
		value: function getTextBlock(APIUrl, blockName) {
			return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.get(APIUrl + "/textblocks?filter[name]=" + blockName);
		}
	}]);

	return FetchService;
}();

/* harmony default export */ __webpack_exports__["a"] = (FetchService);

/***/ }),

/***/ "GllG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IWEu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jdrx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KI/a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_ContactForm__ = __webpack_require__("0kTd");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var $ = __webpack_require__("7t+N");

/* harmony default export */ __webpack_exports__["a"] = ({
	name: "Pricing",
	data: function data() {
		return {
			pageTitle: "Loading...",
			pageInfo: {},
			surveyQuestions: [],
			checkedOptions: [],
			tree: {},
			initList: [],
			mylist: [],
			childrenIds: [],
			NodPointer: 0,
			CurrentQuestionId: 0,
			questionNumber: 1,
			showGoBack: false,
			showGoNext: false,
			goNextIsDisabled: true,
			isChecked: false,
			showForm: false,
			projectEstimation: 0,
			startTime: 0
		};
	},

	components: {
		ContactForm: __WEBPACK_IMPORTED_MODULE_2__modules_ContactForm__["a" /* default */]
	},
	metaInfo: function metaInfo() {
		return {
			title: this.pageTitle,
			meta: [{ itemprop: "name", content: this.pageInfo.meta_og_description }, { itemprop: "description", content: this.pageInfo.meta_og_description }, { name: "og:title", content: this.pageInfo.meta_og_title }, { name: "og:description", content: this.pageInfo.meta_og_description }, { name: "og:url", content: this.pageInfo.meta_url }, { name: "og:site_name", content: this.pageInfo.meta_twitter_site }, { name: "og:type", content: this.pageInfo.meta_og_type }, { name: "og:image", content: this.pageInfo.meta_og_image_url }, { name: "twitter:card", content: this.pageInfo.meta_twitter_card }, { name: "twitter:site", content: this.pageInfo.meta_twitter_site }, { name: "twitter:title", content: this.pageInfo.meta_twitter_title }, {
				name: "twitter:description",
				content: this.pageInfo.meta_twitter_description
			}, {
				name: "twitter:creator",
				content: this.pageInfo.meta_twitter_creator
			}, { name: "twitter:image", content: this.pageInfo.meta_twitter_image_url }]
		};
	},
	created: function created() {
		this.getAll();
		this.getPageInfo();
		this.startTime = new Date();
	},

	methods: {
		getTreeLines: function getTreeLines(dataTree) {
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(dataTree);
		},

		/* GET children of specific node for the given tree by the given id */
		findKey: function findKey(tree, keyObj) {
			var p, key, val, tRet;
			for (p in keyObj) {
				if (keyObj.hasOwnProperty(p)) {
					key = p;
					val = keyObj[p];
				}
			}

			for (p in tree) {
				if (p === key) {
					if (tree[p] === val) {
						return tree;
					}
				} else if (tree[p] instanceof Object) {
					if (tree.hasOwnProperty(p)) {
						tRet = this.findKey(tree[p], keyObj);
						if (tRet) {
							return tRet;
						}
					}
				}
			}

			return false;
		},
		getNodeById: function getNodeById(id) {
			return this.findKey(this.tree, { id: id });
		},
		UIDisplayQuestion: function UIDisplayQuestion(question) {
			if (!question.multi_choice) {
				this.showGoNext = false;
			} else {
				this.showGoNext = true;
			}
			this.surveyQuestions = [];
			this.surveyQuestions.push(question);
		},
		getMylistItemIndex: function getMylistItemIndex(id) {
			var result = -1;

			this.mylist.forEach(function (item, index) {
				if (item.id === id) {
					result = index;
				}
			});

			return result;
		},
		getChildrenIds: function getChildrenIds(obj) {
			for (var key in obj) {
				if (obj[key] !== null && obj[key] instanceof Object) {
					if (obj.hasOwnProperty("type") && obj["type"] === "question") {
						this.childrenIds.push(obj.id);
					}
					/* Recurse into children */
					this.getChildrenIds(obj[key]);
				}
			}

			return this.childrenIds;
		},
		addOptionChildren: function addOptionChildren(node) {
			var _this = this;

			var optionChildren = [];

			if (node.parent_id !== 0) {
				this.showGoBack = true;
			}

			if (node.children) {
				optionChildren = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(node.children);
			}

			if (optionChildren && optionChildren.length > 0) {
				var insertedIndex = this.NodPointer;
				optionChildren.forEach(function (child) {
					if (_this.getMylistItemIndex(child.id) === -1) {
						var oNode = _this.getNodeById(child.id);
						_this.mylist.splice(++insertedIndex, 0, {
							id: parseInt(child.id),
							parent: child.parent_id,
							question: oNode.title,
							option_value: [],
							selectedOptionTitle: []
						});
					}
				});
			}
		},
		multiChoose: function multiChoose(ids, questionId) {
			var _this2 = this;

			this.questionNumber++;

			/* To reset the unselected options */
			var oldSelectedValues = this.mylist[this.getMylistItemIndex(questionId)].option_value.slice();

			/* Reset previous selected options for this question */
			this.mylist[this.getMylistItemIndex(questionId)].option_value = [];
			this.mylist[this.getMylistItemIndex(questionId)].selectedOptionValue = 0;

			ids.forEach(function (id) {
				var node = _this2.getNodeById(id);
				console.log("Chosen node Options :", node.title, node.id);

				// remove from oldSelectedValues
				if (oldSelectedValues.indexOf(id) > -1) {
					oldSelectedValues.splice(oldSelectedValues.indexOf(id), 1);
				}

				// set the question chosen values
				if (_this2.mylist[_this2.getMylistItemIndex(node.parent_id)].option_value.indexOf(id) === -1) {
					_this2.mylist[_this2.getMylistItemIndex(node.parent_id)].option_value.push(id);
					_this2.mylist[_this2.getMylistItemIndex(node.parent_id)].selectedOptionValue += node.value;
					_this2.mylist[_this2.getMylistItemIndex(node.parent_id)].selectedOptionTitle.push(node.title);
				}

				// add the children questions of the selected option
				_this2.addOptionChildren(node);
			});

			// remove the unselected options and it's children
			oldSelectedValues.forEach(function (id) {
				// then remove root children
				var UpParentNode = _this2.getNodeById(id);
				_this2.childrenIds = [];
				_this2.childrenIds = _this2.getChildrenIds(UpParentNode);

				// add the root element to be removed
				_this2.childrenIds.push(id);

				_this2.childrenIds.forEach(function (childId) {
					_this2.mylist.forEach(function (item, index) {
						if (item.id === childId) {
							_this2.mylist.splice(index, 1);
						}
					});
				});
			});
		},
		next: function next() {
			this.NodPointer++;
			this.show();
		},
		optionSelected: function optionSelected(option, questionId) {
			this.projectEstimation += option.value;
			this.multiChoose([option.id], questionId);
			this.next();
		},
		optionCheckboxSelected: function optionCheckboxSelected($event, option, questionId) {
			this.goNextIsDisabled = false;
			if ($event.target.checked) {
				this.projectEstimation += option.value;
			} else {
				this.projectEstimation -= option.value;
			}
		},
		show: function show() {
			if (this.NodPointer < this.mylist.length) {
				this.CurrentQuestionId = this.mylist[this.NodPointer].id;
				console.log("Question : ", this.getNodeById(this.mylist[this.NodPointer].id).title, this.getNodeById(this.mylist[this.NodPointer].id).id);
				this.UIDisplayQuestion(this.getNodeById(this.mylist[this.NodPointer].id));
			} else {
				console.log("USER HAVE BEEN FINISHED!");
				this.showForm = true;
			}
		},
		getCheckOptions: function getCheckOptions() {
			var values = [];
			var questionId = -1;
			$(":checkbox:checked").each(function (item, i) {
				values.push(parseInt($(this).val()));
				questionId = $(this).attr("question");
			});
			return [values, questionId];
		},
		goBack: function goBack() {
			var currQuestionIndex = this.getMylistItemIndex(this.CurrentQuestionId);
			var currentQuestion = this.getNodeById(this.mylist[this.NodPointer].id);
			var _self = this;
			if (this.NodPointer > currQuestionIndex) {
				this.NodPointer = currQuestionIndex;
			}
			var prevQuestion = this.getNodeById(this.mylist[--this.NodPointer].id);
			_self.mylist.forEach(function (item) {
				if (prevQuestion.title === item.question) {
					_self.projectEstimation -= item.selectedOptionValue;
					item.selectedOptionValue = 0;
					item.selectedOptionTitle = [];
					item.option_value = [];
				} else if (currentQuestion.title === item.question) {
					_self.checkedOptions.forEach(function (id) {
						if (currentQuestion.options[id] !== undefined) {
							_self.projectEstimation -= currentQuestion.options[id].value;
						}
					});
				}
			});
			_self.checkedOptions = [];
			this.UIDisplayQuestion(prevQuestion);

			this.questionNumber--;
			if (this.questionNumber === 1) {
				this.showGoBack = false;
			}
		},
		goNext: function goNext() {
			var selectedOptions = this.getCheckOptions()[0];
			var questionId = Number(this.getCheckOptions()[1]);
			if (selectedOptions.length !== 0) {
				this.multiChoose(selectedOptions, questionId);
				this.next();
			} else {
				alert("choose at least one item");
			}
		},
		getPageInfo: function getPageInfo() {
			this.$http.get(this.$parent.$parent.apiURL + "/Pages?id=6").then(function (response) {
				this.pageInfo = response.body;
				this.pageTitle = this.pageInfo.title;
			});
		},
		getAll: function getAll() {
			this.$http.post(this.$parent.$parent.apiURL + "/quotes/get-quote").then(function (response) {
				var _this3 = this;

				this.tree = response.body;
				this.getTreeLines(response.body).forEach(function (id) {
					_this3.initList.push(parseInt(id));
					var node = _this3.getNodeById(parseInt(id));
					_this3.mylist.push({
						id: parseInt(id),
						parent: 0,
						question: node.title,
						option_value: [],
						selectedOptionTitle: []
					});
				});
				this.show();
			});
		}
	}
});

/***/ }),

/***/ "KlKF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__("ORbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_Skills__ = __webpack_require__("ODbV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_Plans__ = __webpack_require__("NJWq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_Clients__ = __webpack_require__("onDg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
	name: "Homepage",
	data: function data() {
		return {
			pageTitle: "Loading...",
			pageInfo: {},
			bannerContent: {},
			sectionProjectContent: {},
			clients: [],
			totalNumberOfProjects: 0
		};
	},

	components: {
		Skills: __WEBPACK_IMPORTED_MODULE_2__modules_Skills__["a" /* default */],
		Plans: __WEBPACK_IMPORTED_MODULE_3__modules_Plans__["a" /* default */],
		Clients: __WEBPACK_IMPORTED_MODULE_4__modules_Clients__["a" /* default */]
	},
	metaInfo: function metaInfo() {
		return {
			title: this.pageTitle,
			meta: [{ itemprop: "name", content: this.pageInfo.meta_og_description }, { itemprop: "description", content: this.pageInfo.meta_og_description }, { name: "og:title", content: this.pageInfo.meta_og_title }, { name: "og:description", content: this.pageInfo.meta_og_description }, { name: "og:url", content: this.pageInfo.meta_url }, { name: "og:site_name", content: this.pageInfo.meta_twitter_site }, { name: "og:type", content: this.pageInfo.meta_og_type }, { name: "og:image", content: this.pageInfo.meta_og_image_url }, { name: "twitter:card", content: this.pageInfo.meta_twitter_card }, { name: "twitter:site", content: this.pageInfo.meta_twitter_site }, { name: "twitter:title", content: this.pageInfo.meta_twitter_title }, {
				name: "twitter:description",
				content: this.pageInfo.meta_twitter_description
			}, {
				name: "twitter:creator",
				content: this.pageInfo.meta_twitter_creator
			}, { name: "twitter:image", content: this.pageInfo.meta_twitter_image_url }]
		};
	},
	created: function created() {
		this.getPageInfo();
		this.getAll();
	},

	methods: {
		getPageInfo: function getPageInfo() {
			this.$http.get(this.$parent.$parent.apiURL + "/Pages?id=7").then(function (response) {
				this.pageInfo = response.body;
				this.pageTitle = this.pageInfo.title;
			});
		},
		getAll: function getAll() {
			this.$http.get(this.$parent.$parent.apiURL + "/textblocks/text-blocks-widgets?filter[name]=homepage-section-banner").then(function (response) {
				this.bannerContent = response.body.widget_blocks[0];
			});
			this.$http.get(this.$parent.$parent.apiURL + "/textblocks/text-blocks-widgets?filter[name]=homepage-section-projects").then(function (response) {
				this.sectionProjectContent = response.body.widget_blocks[0];
				this.totalNumberOfProjects = this.sectionProjectContent.title;
			});
		}
	}
});

/***/ }),

/***/ "L8C9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M+cg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: "Clients",
	data: function data() {
		return {
			clients: [],
			sectionClientsContent: {}
		};
	},
	mounted: function mounted() {
		this.getAll();
	},

	methods: {
		getAll: function getAll() {
			this.$http.get(this.$parent.$parent.$parent.apiURL + "/clients").then(function (response) {
				this.clients = response.body;
			});
			this.$http.get(this.$parent.$parent.$parent.apiURL + "/textblocks?filter[name]=homepage-section-clients").then(function (response) {
				this.sectionClientsContent = response.body;
			});
		}
	}
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31c15228_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("nzlz");
function injectStyle (ssrContext) {
  __webpack_require__("OXud")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31c15228_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MZm1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner-icons-ar.8225a20.png";

/***/ }),

/***/ "Mkwv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pricing_vue__ = __webpack_require__("KI/a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89fb6054_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pricing_vue__ = __webpack_require__("74w9");
function injectStyle (ssrContext) {
  __webpack_require__("G674")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-89fb6054"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pricing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89fb6054_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pricing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("cHtD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n__ = __webpack_require__("9Tyx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_analytics__ = __webpack_require__("AYPi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_analytics__);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = true;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
	el: "#app",
	replace: false,
	router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
	i18n: __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */],
	render: function render(h) {
		return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
	},
	data: {
		// apiURL: 'http://dev-api.softcare.io/api/v1/' + i18n.locale + '/cms'
		apiURL: "http://api.softcare.io/api/v1/" + __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].locale + "/cms"
	}
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_analytics___default.a, {
	id: "UA-108021089-1",
	router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]
});

/***/ }),

/***/ "NJWq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Plans_vue__ = __webpack_require__("3DAb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e04ea41c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Plans_vue__ = __webpack_require__("ocGb");
function injectStyle (ssrContext) {
  __webpack_require__("BrpM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e04ea41c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Plans_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e04ea41c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Plans_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "O8r0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lang-arabic.9615d98.svg";

/***/ }),

/***/ "ODbV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Skills_vue__ = __webpack_require__("pwfS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe68cc2c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Skills_vue__ = __webpack_require__("64hC");
function injectStyle (ssrContext) {
  __webpack_require__("Yr9d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fe68cc2c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Skills_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe68cc2c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Skills_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OXud":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P53f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section section-clients align-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"section__header"},[_c('h1',{staticClass:"headline section__header__headline"},[_vm._v(_vm._s(_vm.sectionClientsContent.title))]),_vm._v(" "),_c('span',{staticClass:"section__header__tagline"},[_vm._v(_vm._s(_vm.sectionClientsContent.sub_title))])]),_vm._v(" "),_vm._l((_vm.clients),function(client){return _c('img',{key:client.id,staticClass:"responsive-image",attrs:{"alt":client.name,"title":client.name,"src":client.logo_url,"width":client.bio}})})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PcHo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: "Projects",
	data: function data() {
		return {
			pageTitle: "Loading...",
			pageInfo: {},
			projects: []
		};
	},
	metaInfo: function metaInfo() {
		return {
			title: this.pageTitle,
			meta: [{ itemprop: "name", content: this.pageInfo.meta_og_description }, { itemprop: "description", content: this.pageInfo.meta_og_description }, { name: "og:title", content: this.pageInfo.meta_og_title }, { name: "og:description", content: this.pageInfo.meta_og_description }, { name: "og:url", content: this.pageInfo.meta_url }, { name: "og:site_name", content: this.pageInfo.meta_twitter_site }, { name: "og:type", content: this.pageInfo.meta_og_type }, { name: "og:image", content: this.pageInfo.meta_og_image_url }, { name: "twitter:card", content: this.pageInfo.meta_twitter_card }, { name: "twitter:site", content: this.pageInfo.meta_twitter_site }, { name: "twitter:title", content: this.pageInfo.meta_twitter_title }, {
				name: "twitter:description",
				content: this.pageInfo.meta_twitter_description
			}, {
				name: "twitter:creator",
				content: this.pageInfo.meta_twitter_creator
			}, { name: "twitter:image", content: this.pageInfo.meta_twitter_image_url }]
		};
	},
	created: function created() {
		this.getAll();
		this.getPageInfo();
	},

	methods: {
		getPageInfo: function getPageInfo() {
			this.$http.get(this.$parent.$parent.apiURL + "/Pages?id=5").then(function (response) {
				this.pageInfo = response.body;
				this.pageTitle = this.pageInfo.title;
			});
		},
		getAll: function getAll() {
			this.$http.get(this.$parent.$parent.apiURL + "/projects").then(function (response) {
				this.projects = response.body;
			});
		}
	}
});

/***/ }),

/***/ "Qfom":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Homepage_vue__ = __webpack_require__("KlKF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65cecbe4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Homepage_vue__ = __webpack_require__("G/Ls");
function injectStyle (ssrContext) {
  __webpack_require__("tBOW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-65cecbe4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Homepage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65cecbe4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Homepage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RmGw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header__top container"},[_c('router-link',{attrs:{"to":{ name: 'home', params: { lang: this.$i18n.locale }}}},[(this.$i18n.locale == 'en')?_c('img',{staticClass:"logo responsive-image",attrs:{"src":__webpack_require__("p19O"),"width":"200px"}}):_vm._e(),_vm._v(" "),(this.$i18n.locale == 'ar')?_c('img',{staticClass:"logo responsive-image",attrs:{"src":__webpack_require__("8Tel"),"width":"200px"}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"menu"},[_c('div',{staticClass:"nav-button hidden-lg",class:{ 'close-menu' : _vm.isVisibleMegaMenu },on:{"click":_vm.toggleMegaMenu}},[_vm._m(0)]),_vm._v(" "),_c('ul',{staticClass:"inline-list",class:{ 'mega-menu-opened' : _vm.isVisibleMegaMenu }},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'about', params: { lang: this.$i18n.locale }}}},[_vm._v(_vm._s(_vm.$t("menu.aboutUs")))])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'services', params: { lang: this.$i18n.locale }}}},[_vm._v(_vm._s(_vm.$t("menu.services")))])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'projects', params: { lang: this.$i18n.locale }}}},[_vm._v(_vm._s(_vm.$t("menu.projects")))])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'blog', params: { lang: this.$i18n.locale }}}},[_vm._v(_vm._s(_vm.$t("menu.blog")))])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'contact', params: { lang: this.$i18n.locale }}}},[_vm._v(_vm._s(_vm.$t("menu.contactUs")))])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'pricing', params: { lang: this.$i18n.locale }}}},[_c('a',{staticClass:"button button--primary button--primary__small"},[_c('span',{staticClass:"button--primary__text",attrs:{"exact":""}},[_vm._v(_vm._s(_vm.$t("global.getAnEstimation")))])])])],1)]),_vm._v(" "),(this.$i18n.locale == 'en')?_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom-center",value:(_vm.toArabic),expression:"toArabic",modifiers:{"bottom-center":true}}],on:{"click":function($event){$event.preventDefault();_vm.setLanguage('ar')}}},[_c('img',{staticClass:"responsive-image",attrs:{"src":__webpack_require__("O8r0"),"width":"30","alt":""}})]):_vm._e(),_vm._v(" "),(this.$i18n.locale == 'ar')?_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom-center",value:(_vm.toEnglish),expression:"toEnglish",modifiers:{"bottom-center":true}}],on:{"click":function($event){$event.preventDefault();_vm.setLanguage('en')}}},[_c('img',{staticClass:"responsive-image",attrs:{"src":__webpack_require__("mc5j"),"width":"30","alt":""}})]):_vm._e()])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hamburger"},[_c('div',{staticClass:"line"}),_vm._v(" "),_c('div',{staticClass:"line"}),_vm._v(" "),_c('div',{staticClass:"line"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SGec":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Blog_vue__ = __webpack_require__("CHQz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e76af87c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Blog_vue__ = __webpack_require__("1Xeb");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Blog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e76af87c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Blog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XgTB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"contact-form-container col-md-6 col-sm-8 col-xs-12",on:{"submit":function($event){$event.preventDefault();_vm.validateBeforeSubmit(_vm.ContactUsForm.message)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col-md-12 col-xs-12"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.ContactUsForm.message.fullName),expression:"ContactUsForm.message.fullName"}],class:{'is-danger': _vm.errors.has('fullName') },attrs:{"name":"fullName","type":"text"},domProps:{"value":(_vm.ContactUsForm.message.fullName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.ContactUsForm.message, "fullName", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"fullName"}},[_vm._v(_vm._s(_vm.$t("form.fullName")))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('fullName')),expression:"errors.has('fullName')"}],staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.errors.first('fullName')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col-md-12 col-xs-12"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"},{name:"model",rawName:"v-model",value:(_vm.ContactUsForm.message.email),expression:"ContactUsForm.message.email"}],class:{'is-danger': _vm.errors.has('email') },attrs:{"name":"email","type":"email"},domProps:{"value":(_vm.ContactUsForm.message.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.ContactUsForm.message, "email", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"email"}},[_vm._v(_vm._s(_vm.$t("form.emailAddress")))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('email')),expression:"errors.has('email')"}],staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.errors.first('email')))])])]),_vm._v(" "),_c('div',{staticClass:"row m-b-20 m-t-20"},[_c('div',{staticClass:"col-md-12 col-xs-12"},[_c('h6',{staticClass:"m-b-20"},[_vm._v(_vm._s(_vm.$t("form.yourReferal")))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.referalSource),expression:"referalSource"}],attrs:{"value":"Google Search","name":"referal","type":"radio","id":"google"},domProps:{"checked":_vm._q(_vm.referalSource,"Google Search")},on:{"change":function($event){_vm.referalSource="Google Search"}}}),_vm._v(" "),_c('label',{attrs:{"for":"google"}},[_vm._v(_vm._s(_vm.$t("referal.google")))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.referalSource),expression:"referalSource"}],attrs:{"data-vv-as":"Referal Source","value":"Social Media: Twitter, LinkedIn","name":"referal","type":"radio","id":"social"},domProps:{"checked":_vm._q(_vm.referalSource,"Social Media: Twitter, LinkedIn")},on:{"change":function($event){_vm.referalSource="Social Media: Twitter, LinkedIn"}}}),_vm._v(" "),_c('label',{attrs:{"for":"social"}},[_vm._v(_vm._s(_vm.$t("referal.social")))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.referalSource),expression:"referalSource"}],attrs:{"data-vv-as":"Referal Source","value":"A Friend","name":"referal","type":"radio","id":"friend"},domProps:{"checked":_vm._q(_vm.referalSource,"A Friend")},on:{"change":function($event){_vm.referalSource="A Friend"}}}),_vm._v(" "),_c('label',{attrs:{"for":"friend"}},[_vm._v(_vm._s(_vm.$t("referal.friend")))]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.referalSource),expression:"referalSource"}],attrs:{"data-vv-as":"Referal Source","value":"Other","name":"referal","type":"radio","id":"other"},domProps:{"checked":_vm._q(_vm.referalSource,"Other")},on:{"change":function($event){_vm.referalSource="Other"}}}),_vm._v(" "),_c('label',{attrs:{"for":"other"}},[_vm._v(_vm._s(_vm.$t("referal.other")))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('referal')),expression:"errors.has('referal')"}],staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.errors.first('referal')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-field col-md-12 col-xs-12"},[_c('textarea',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.ContactUsForm.message.messageContent),expression:"ContactUsForm.message.messageContent"}],staticClass:"materialize-textarea",class:{'is-danger': _vm.errors.has('message') },attrs:{"name":"message"},domProps:{"value":(_vm.ContactUsForm.message.messageContent)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.ContactUsForm.message, "messageContent", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"textarea1"}},[_vm._v(_vm._s(_vm.$t("form.message")))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('message')),expression:"errors.has('message')"}],staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.errors.first('message')))])])]),_vm._v(" "),_c('div',{staticClass:"row end-md buttonContainer xs-block"},[_c('button',{staticClass:"button button--primary dsButtonAnim",class:{ loading: _vm.contactMessageRequest},attrs:{"type":"submit"}},[_c('span',{staticClass:"button--primary__text"},[_vm._v(_vm._s(_vm.$t("form.sendYourMessage")))])])]),_vm._v(" "),_c('div',{staticClass:"row m-b-20 m-t-20"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.messageSendingError),expression:"messageSendingError"}],staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.$t("form.messageSendingError")))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.messageSendingSuccess),expression:"messageSendingSuccess"}],staticClass:"help is-success"},[_vm._v(_vm._s(_vm.$t("form.messageSendingSuccess")))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XptN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: "Services",
	data: function data() {
		return {
			pageTitle: "Loading...",
			pageInfo: {},
			softwareSolutions: [],
			marketingSolutions: []
		};
	},
	metaInfo: function metaInfo() {
		return {
			title: this.pageTitle,
			meta: [{ itemprop: "name", content: this.pageInfo.meta_og_description }, { itemprop: "description", content: this.pageInfo.meta_og_description }, { name: "og:title", content: this.pageInfo.meta_og_title }, { name: "og:description", content: this.pageInfo.meta_og_description }, { name: "og:url", content: this.pageInfo.meta_url }, { name: "og:site_name", content: this.pageInfo.meta_twitter_site }, { name: "og:type", content: this.pageInfo.meta_og_type }, { name: "og:image", content: this.pageInfo.meta_og_image_url }, { name: "twitter:card", content: this.pageInfo.meta_twitter_card }, { name: "twitter:site", content: this.pageInfo.meta_twitter_site }, { name: "twitter:title", content: this.pageInfo.meta_twitter_title }, {
				name: "twitter:description",
				content: this.pageInfo.meta_twitter_description
			}, {
				name: "twitter:creator",
				content: this.pageInfo.meta_twitter_creator
			}, { name: "twitter:image", content: this.pageInfo.meta_twitter_image_url }]
		};
	},
	created: function created() {
		this.getPageInfo();
		this.getAll();
	},

	methods: {
		getAll: function getAll() {
			this.$http.get(this.$parent.$parent.apiURL + "/textblocks/text-blocks-widgets?filter[name]=services-software-solutions").then(function (response) {
				this.softwareSolutions = response.body.widget_blocks;
			});

			this.$http.get(this.$parent.$parent.apiURL + "/textblocks/text-blocks-widgets?filter[name]=service-digital-marketing").then(function (response) {
				this.marketingSolutions = response.body.widget_blocks;
			});
		},
		getPageInfo: function getPageInfo() {
			this.$http.get(this.$parent.$parent.apiURL + "/Pages?id=8").then(function (response) {
				this.pageInfo = response.body;
				this.pageTitle = this.pageInfo.title;
			});
		}
	}
});

/***/ }),

/***/ "YI6p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__("jIen");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7847c931_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__("6aPd");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7847c931_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Yr9d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZCdO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"container-fluid"},[_c('div',{staticClass:"page-headline m-b-20 m-t-70 align-center"},[_c('h1',{staticClass:"headline page-headline__title m-b-20"},[_vm._v(_vm._s(_vm.pageInfo.title))])]),_vm._v(" "),_c('div',{staticClass:"row section center-md align-center"},[_c('div',{staticClass:"col-md-12 col-xs-12"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.pageInfo.content)}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Zs8U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "About",
  data: function data() {
    return {
      pageTitle: "Loading...",
      pageInfo: {},
      aboutCompany: [],
      companyStory: [],
      sectionOurStoryContent: {},
      sectionEnviromentContent: {},
      clients: [],
      sectionClientsContent: {},
      photoGallery: [],
      profileUrl: this.$i18n.locale === "en" ? "http://softcare.io/company_profile_en.pdf" : "http://softcare.io/company_profile_ar.pdf"
    };
  },
  metaInfo: function metaInfo() {
    return {
      title: this.pageTitle,
      meta: [{ itemprop: "name", content: this.pageInfo.meta_og_description }, { itemprop: "description", content: this.pageInfo.meta_og_description }, { name: "og:title", content: this.pageInfo.meta_og_title }, { name: "og:description", content: this.pageInfo.meta_og_description }, { name: "og:url", content: this.pageInfo.meta_url }, { name: "og:site_name", content: this.pageInfo.meta_twitter_site }, { name: "og:type", content: this.pageInfo.meta_og_type }, { name: "og:image", content: this.pageInfo.meta_og_image_url }, { name: "twitter:card", content: this.pageInfo.meta_twitter_card }, { name: "twitter:site", content: this.pageInfo.meta_twitter_site }, { name: "twitter:title", content: this.pageInfo.meta_twitter_title }, {
        name: "twitter:description",
        content: this.pageInfo.meta_twitter_description
      }, {
        name: "twitter:creator",
        content: this.pageInfo.meta_twitter_creator
      }, { name: "twitter:image", content: this.pageInfo.meta_twitter_image_url }]
    };
  },
  created: function created() {
    this.getAll();
    this.getPageInfo();
  },

  methods: {
    getPageInfo: function getPageInfo() {
      this.$http.get(this.$parent.$parent.apiURL + "/Pages?id=3").then(function (response) {
        this.pageInfo = response.body;
        this.pageTitle = this.pageInfo.title;
      });
    },
    getAll: function getAll() {
      this.$http.get(this.$parent.$parent.apiURL + "/Photogalleries?id=2").then(function (response) {
        this.photoGallery = response.body.photos;
      });

      this.$http.get(this.$parent.$parent.apiURL + "/clients").then(function (response) {
        this.clients = response.body;
      });

      this.$http.get(this.$parent.$parent.apiURL + "/textblocks?filter[name]=homepage-section-clients").then(function (response) {
        this.sectionClientsContent = response.body;
      });

      this.$http.get(this.$parent.$parent.apiURL + "/textblocks/text-blocks-widgets?filter[name]=page-about-us").then(function (response) {
        this.aboutCompany = response.body.widget_blocks;
      });

      this.$http.get(this.$parent.$parent.apiURL + "/textblocks/text-blocks-widgets?filter[name]=page-about-us-story").then(function (response) {
        this.companyStory = response.body.widget_blocks;
      });

      this.$http.get(this.$parent.$parent.apiURL + "/textblocks?filter[name]=about-us-section-story").then(function (response) {
        this.sectionOurStoryContent = response.body;
      });

      this.$http.get(this.$parent.$parent.apiURL + "/textblocks?filter[name]=about-us-section-enviroment").then(function (response) {
        this.sectionEnviromentContent = response.body;
      });
    }
  }
});

/***/ }),

/***/ "bgOd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Services_vue__ = __webpack_require__("XptN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ec6227e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Services_vue__ = __webpack_require__("+Dbj");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Services_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ec6227e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Services_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c27y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__("Zs8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7593561d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__("eLJK");
function injectStyle (ssrContext) {
  __webpack_require__("Jdrx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7593561d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7593561d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cHtD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_meta__ = __webpack_require__("p3jY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_About__ = __webpack_require__("c27y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Blog__ = __webpack_require__("SGec");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_BlogDetails__ = __webpack_require__("rhQ2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Contact__ = __webpack_require__("FnhZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Homepage__ = __webpack_require__("Qfom");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Pricing__ = __webpack_require__("Mkwv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Privacy__ = __webpack_require__("8mQd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Projects__ = __webpack_require__("uwSr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Services__ = __webpack_require__("bgOd");














__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_meta___default.a);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	mode: "history",
	routes: [{ name: "home", path: "/:lang", component: __WEBPACK_IMPORTED_MODULE_7__components_Homepage__["a" /* default */] }, { name: "about", path: "/:lang/about-softcare", component: __WEBPACK_IMPORTED_MODULE_3__components_About__["a" /* default */] }, { name: "blog", path: "/:lang/blog", component: __WEBPACK_IMPORTED_MODULE_4__components_Blog__["a" /* default */] }, { path: "/:lang/blog/:slug", component: __WEBPACK_IMPORTED_MODULE_5__components_BlogDetails__["a" /* default */] }, { name: "contact", path: "/:lang/contact", component: __WEBPACK_IMPORTED_MODULE_6__components_Contact__["a" /* default */] }, { name: "privacy", path: "/:lang/privacy", component: __WEBPACK_IMPORTED_MODULE_9__components_Privacy__["a" /* default */] }, { name: "pricing", path: "/:lang/pricing", component: __WEBPACK_IMPORTED_MODULE_8__components_Pricing__["a" /* default */] }, { name: "projects", path: "/:lang/projects", component: __WEBPACK_IMPORTED_MODULE_10__components_Projects__["a" /* default */] }, { name: "services", path: "/:lang/services", component: __WEBPACK_IMPORTED_MODULE_11__components_Services__["a" /* default */] }, { path: "*", component: __WEBPACK_IMPORTED_MODULE_7__components_Homepage__["a" /* default */] }]
});

var self = this;
router.beforeEach(function (to, from, next) {
	if (to.params.lang) {
		next();
	} else {
		next("/" + self.a.app.$options.i18n.locale);
	}
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "dXWr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('Top-Footer'),_vm._v(" "),_c('Bottom-Footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "e9cm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PreLoader_vue__ = __webpack_require__("yqhT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15226e1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PreLoader_vue__ = __webpack_require__("GPmT");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PreLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15226e1e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PreLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eDj8":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "eLJK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"container-fluid"},[_c('div',{staticClass:"page-headline m-b-20 m-t-70 align-center"},[_c('h1',{staticClass:"headline page-headline__title m-b-20"},[_vm._v(_vm._s(_vm.pageInfo.title))]),_vm._v(" "),_c('h4',{staticClass:"tagline page-headline__tagline about--description",domProps:{"innerHTML":_vm._s(_vm.pageInfo.content)}})]),_vm._v(" "),_c('div',{staticClass:"align-center"},[_c('a',{staticClass:"button button--primary",attrs:{"target":"_blank","rel":"noopener","href":_vm.profileUrl}},[_c('span',{staticClass:"button--primary__text"},[_vm._v(_vm._s(_vm.$t("global.companyProfile")))])])]),_vm._v(" "),_c('div',{staticClass:"row section center-md align-center"},_vm._l((_vm.aboutCompany),function(about){return _c('div',{key:about.id,staticClass:"col-md-4 col-sm-6 m-b-20-xs"},[_c('h1',{staticClass:"headline m-b-30"},[_vm._v(_vm._s(about.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(about.content))])])})),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row section the-story"},[_c('div',{staticClass:"col-lg-6 col-md-6 col-sm-12 col-xs-12 m-b-20-xs"},[_c('h3',{staticClass:"headline"},[_vm._v(_vm._s(_vm.sectionOurStoryContent.title))]),_vm._v(" "),_c('span',{staticClass:"tagline",domProps:{"innerHTML":_vm._s(_vm.sectionOurStoryContent.content)}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6 col-sm-12 col-xs-12"},_vm._l((_vm.companyStory),function(story){return _c('div',{key:story.id,staticClass:"story__step m-b-30"},[_c('h3',[_vm._v(_vm._s(story.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(story.content))])])}))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row section"},[_c('h3',{staticClass:"headline m-b-30"},[_vm._v("\n      "+_vm._s(_vm.sectionEnviromentContent.title)+"\n      "),_c('span',{staticClass:"tagline"},[_vm._v(_vm._s(_vm.sectionEnviromentContent.sub_title))])]),_vm._v(" "),_c('div',{staticClass:"row about-gallery"},_vm._l((_vm.photoGallery),function(image,index){return _c('img',{key:index,staticClass:"col-md-4 col-xs-12 image-box image--gray responsive-image",attrs:{"src":image.image_url}})}))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"section section-clients align-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"section__header"},[_c('h1',{staticClass:"headline section__header__headline"},[_vm._v(_vm._s(_vm.sectionClientsContent.title))]),_vm._v(" "),_c('span',{staticClass:"section__header__tagline"},[_vm._v(_vm._s(_vm.sectionClientsContent.sub_title))])]),_vm._v(" "),_c('div',{staticClass:"m-b-30"},_vm._l((_vm.clients),function(client){return _c('img',{key:client.id,staticClass:"responsive-image",attrs:{"alt":client.name,"width":client.bio,"title":client.name,"src":client.logo_url}})})),_vm._v(" "),_c('router-link',{staticClass:"button button--primary",attrs:{"to":{ name: 'pricing', params: { lang: this.$i18n.locale }}}},[_c('span',{staticClass:"button--primary__text"},[_vm._v(_vm._s(_vm.$t("global.becomeAClient")))])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jqHA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FooterComponents_TopFooter__ = __webpack_require__("7COe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FooterComponents_BottomFooter__ = __webpack_require__("o8/y");
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "MainFooter",
  props: ["preLoading"],
  data: function data() {
    return {};
  },

  components: {
    TopFooter: __WEBPACK_IMPORTED_MODULE_0__FooterComponents_TopFooter__["a" /* default */],
    BottomFooter: __WEBPACK_IMPORTED_MODULE_1__FooterComponents_BottomFooter__["a" /* default */]
  },
  mounted: function mounted() {
    setTimeout(this.disabledPreLoading, 3000);
  },

  methods: {
    disabledPreLoading: function disabledPreLoading() {
      this.$emit("update:preLoading", false);
    }
  }
});

/***/ }),

/***/ "kXtM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_FetchService__ = __webpack_require__("GX/j");
//
//
//
//
//
//


var fetchService = new __WEBPACK_IMPORTED_MODULE_0__services_FetchService__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "BottomFooter",
  data: function data() {
    return {
      bottomFooterTagline: ""
    };
  },

  methods: {
    getAll: function getAll() {
      var _this = this;

      fetchService.getTextBlock(this.$parent.$parent.$parent.apiURL, "bottom-footer-tagline").then(function (response) {
        _this.bottomFooterTagline = response.body.content;
      });
    }
  },
  created: function created() {
    this.getAll();
  }
});

/***/ }),

/***/ "lXxY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/marketing-services-steps-en.d7cbcd8.png";

/***/ }),

/***/ "lxBQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner-icons-en.a0f83a6.png";

/***/ }),

/***/ "mc5j":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "nmO7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nzlz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.$i18n.locale == 'ar')?_c('link',{attrs:{"rel":"stylesheet","href":"../static/stylesheets/screen-ar.css"}}):_vm._e(),_vm._v(" "),(this.$i18n.locale == 'en')?_c('link',{attrs:{"rel":"stylesheet","href":"../static/stylesheets/screen-en-US.css"}}):_vm._e(),_vm._v(" "),_c('Pre-Loader',{directives:[{name:"show",rawName:"v-show",value:(_vm.isPreLoading),expression:"isPreLoading"}]}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isPreLoading),expression:"!isPreLoading"}],staticClass:"wrapper"},[_c('header',{staticClass:"header has-shadow"},[_c('Main-Header',{attrs:{"pre-loading":_vm.isPreLoading},on:{"update:preLoading":function($event){_vm.isPreLoading=$event}}})],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1),_vm._v(" "),_c('Main-Footer',{attrs:{"pre-loading":_vm.isPreLoading},on:{"update:preLoading":function($event){_vm.isPreLoading=$event}}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "o8/y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BottomFooter_vue__ = __webpack_require__("kXtM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70c6908c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BottomFooter_vue__ = __webpack_require__("tOCZ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BottomFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70c6908c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BottomFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ocGb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section section-solutions align-center has-shadow"},[_c('div',{staticClass:"section__header"},[_c('h1',{staticClass:"headline section__header__headline"},[_vm._v(_vm._s(_vm.sectionPlansContent.title))]),_vm._v(" "),_c('span',{staticClass:"section__header__tagline"},[_vm._v(_vm._s(_vm.sectionPlansContent.sub_title))])]),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},_vm._l((_vm.plans),function(plan){return _c('div',{key:plan.id,staticClass:"col-xs-12 col-md-4 col-lg-4 solution"},[_c('object',{ref:"mySVG",refInFor:true,attrs:{"id":plan.id,"type":"image/svg+xml","width":"300px","data":plan.image_url}}),_vm._v(" "),_c('div',{staticClass:"solution__desc has-shadow"},[_c('h1',{staticClass:"headline section__header__headline"},[_vm._v(_vm._s(plan.title))]),_vm._v(" "),_c('p',{staticClass:"tagline section__header__tagline"},[_vm._v(_vm._s(plan.content))]),_vm._v(" "),_c('router-link',{staticClass:"button button--primary",attrs:{"to":{ path: _vm.$parent.$parent.$i18n.locale + plan.url }}},[_c('span',{staticClass:"button--primary__text"},[_vm._v(_vm._s(_vm.$t("global.getAnEstimation")))])])],1)])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "onDg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Clients_vue__ = __webpack_require__("M+cg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52aac2e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Clients_vue__ = __webpack_require__("P53f");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Clients_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52aac2e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Clients_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "p19O":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/softcare-logo-en.d67b7fa.png";

/***/ }),

/***/ "preG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__ = __webpack_require__("osty");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3480b616_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__("4xqg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3480b616_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "pwH5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: "TopFooter",
	data: function data() {
		return {
			companyProfile: {},
			footerMenu_1: {},
			news: []
		};
	},
	mounted: function mounted() {
		this.getAll();
	},

	methods: {
		getAll: function getAll() {
			this.$http.get(this.$parent.$parent.$parent.apiURL + "/Companyprofiles").then(function (response) {
				this.companyProfile = response.body[0];
			});
			this.$http.post(this.$parent.$parent.$parent.apiURL + "/menus/get-menu?id=3").then(function (response) {
				this.footerMenu_1 = response.body;
			});
			this.$http.get(this.$parent.$parent.$parent.apiURL + "/news").then(function (response) {
				this.news = response.body;
			});
		}
	}
});

/***/ }),

/***/ "pwfS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_nav_tabs__ = __webpack_require__("lEct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_nav_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_nav_tabs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_nav_tabs___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
	extends: __WEBPACK_IMPORTED_MODULE_1_vue_nav_tabs___default.a,
	name: "Skills",
	data: function data() {
		return {
			whatWeDo: {}
		};
	},
	mounted: function mounted() {
		this.getAll();
	},

	methods: {
		getAll: function getAll() {
			this.$http.get(this.$parent.$parent.$parent.apiURL + "/textblocks/text-blocks-widgets?filter[name]=homepage-section-what-we-do").then(function (response) {
				this.whatWeDo = response.body.widget_blocks;
			});
		}
	}
});

/***/ }),

/***/ "rhQ2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogDetails_vue__ = __webpack_require__("FhpU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a19a7160_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogDetails_vue__ = __webpack_require__("sxZs");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlogDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a19a7160_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlogDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "siKq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sxZs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"blog-entery"},[_c('div',{staticClass:"blog-entery__cover m-b-30",style:({ backgroundImage: 'url(' + _vm.pageInfo.feature_image_url + ')' })},[_c('div',{staticClass:"blog-entery__cover__title"},[_c('div',{staticClass:"title align-center"},[_c('h1',[_vm._v(_vm._s(_vm.pageInfo.title)+" - "+_vm._s(_vm.$t("websiteName")))]),_vm._v(" "),_c('h6',[_vm._v(_vm._s(_vm.pageInfo.source_name)+" - "+_vm._s(_vm.pageInfo.date))])])])]),_vm._v(" "),_c('div',{staticClass:"container blog-entery__content row"},[_c('div',{staticClass:"col-md-3 col-md-offset-1 col-xs-12"},[_c('div',{staticClass:"social-sharing-container"},[(_vm.pageInfo.author)?_c('div',{staticClass:"blog-entery__author"},[_c('small',[_vm._v(_vm._s(_vm.$t("global.by")))]),_vm._v(" "),_c('h5',{staticClass:"author-name"},[_vm._v(_vm._s(_vm.pageInfo.author.name))]),_vm._v(" "),_c('p',{staticClass:"author-bio"},[_vm._v(_vm._s(_vm.pageInfo.author.bio))]),_vm._v(" "),(_vm.pageInfo.author.twitter_url != '')?_c('a',{staticClass:"icon-link",attrs:{"target":"_blank","rel":"noopener","href":_vm.pageInfo.author.twitter_url}},[_c('i',{staticClass:"fa fa-twitter",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.pageInfo.author.linkedin_url != '')?_c('a',{staticClass:"icon-link",attrs:{"target":"_blank","rel":"noopener","href":_vm.pageInfo.author.linkedin_url}},[_c('i',{staticClass:"fa fa-linkedin",attrs:{"aria-hidden":"true"}})]):_vm._e()]):_vm._e(),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.$t("global.share")))]),_vm._v(" "),_c('social-sharing',{attrs:{"url":_vm.pageUrl,"title":_vm.pageTitle,"description":_vm.pageInfo.meta_twitter_description,"hashtags":"softcareio","twitter-user":"softcareio"},inlineTemplate:{render:function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social-sharing"},[_c('network',{staticClass:"share-network",attrs:{"network":"facebook"}},[_c('i',{staticClass:"fa fa-fw fa-facebook"}),_vm._v(" "+_vm._s(_vm.$t("global.facebook"))+"\n                ")]),_vm._v(" "),_c('network',{staticClass:"share-network",attrs:{"network":"linkedin"}},[_c('i',{staticClass:"fa fa-fw fa-linkedin"}),_vm._v(" "+_vm._s(_vm.$t("global.linkedIn"))+"\n                ")]),_vm._v(" "),_c('network',{staticClass:"share-network",attrs:{"network":"twitter"}},[_c('i',{staticClass:"fa fa-fw fa-twitter"}),_vm._v(" "+_vm._s(_vm.$t("global.twitter"))+"\n                ")])],1)},staticRenderFns:[]}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-1 col-xs-12",domProps:{"innerHTML":_vm._s(_vm.pageInfo.content)}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tBOW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tN2c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainFooter_vue__ = __webpack_require__("jqHA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7198c15c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainFooter_vue__ = __webpack_require__("dXWr");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7198c15c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tOCZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer__bottom align-center"},[_c('p',[_vm._v(_vm._s(_vm.bottomFooterTagline))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uwSr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Projects_vue__ = __webpack_require__("PcHo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd5e86cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Projects_vue__ = __webpack_require__("xmSn");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Projects_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd5e86cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Projects_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x8P4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainHeader_vue__ = __webpack_require__("3MQM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da69b564_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainHeader_vue__ = __webpack_require__("RmGw");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da69b564_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modules_PreLoader__ = __webpack_require__("e9cm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modules_MainHeader__ = __webpack_require__("x8P4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modules_MainFooter__ = __webpack_require__("tN2c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_flexboxgrid_dist_flexboxgrid_min_css__ = __webpack_require__("siKq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_flexboxgrid_dist_flexboxgrid_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_flexboxgrid_dist_flexboxgrid_min_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app",
  data: function data() {
    return {
      isPreLoading: true
    };
  },

  components: {
    PreLoader: __WEBPACK_IMPORTED_MODULE_0__components_modules_PreLoader__["a" /* default */],
    MainHeader: __WEBPACK_IMPORTED_MODULE_1__components_modules_MainHeader__["a" /* default */],
    MainFooter: __WEBPACK_IMPORTED_MODULE_2__components_modules_MainFooter__["a" /* default */]
  }
});

/***/ }),

/***/ "xmSn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"m-t-70"},[_c('div',{staticClass:"page-headline m-b-30 m-t-70 align-center"},[_c('h1',{staticClass:"headline page-headline__title m-b-20"},[_vm._v(_vm._s(_vm.pageInfo.title))]),_vm._v(" "),_c('h4',{staticClass:"tagline page-headline__tagline",domProps:{"innerHTML":_vm._s(_vm.pageInfo.content)}})]),_vm._v(" "),_c('div',{staticClass:"container-fluid"},_vm._l((_vm.projects),function(project){return _c('fieldset',{key:project.id,staticClass:"section section__fieldset-project",style:({ backgroundImage: 'url(' + project.feature_image_url + ')' })},[_c('legend',[_vm._v(_vm._s(project.title))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7 col-xs-12"},[_c('div',{staticClass:"section__header"},[_c('h1',{staticClass:"headline section__header__headline"},[_vm._v(_vm._s(project.title))]),_vm._v(" "),_c('p',{staticClass:"tagline section__header__tagline"},[_vm._v(_vm._s(project.summary))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-xs-12"},[_c('ul',{staticClass:"section__fieldset-project__details"},[_c('li',[_vm._v(_vm._s(_vm.$t("project.projectType")))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(project.project_type))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-xs-12"},[_c('ul',{staticClass:"section__fieldset-project__details"},[_c('li',[_vm._v(_vm._s(_vm.$t("project.clientName")))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(project.client))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-xs-12"},[_c('ul',{staticClass:"section__fieldset-project__details"},[_c('li',[_vm._v(_vm._s(_vm.$t("project.liveVersion")))]),_vm._v(" "),(project.site_url != '')?_c('li',[_c('a',{attrs:{"target":"_blank","rel":"noopener","href":project.site_url}},[_c('i',{staticClass:"fa fa-globe",attrs:{"aria-hidden":"true"}}),_vm._v("\n                        "+_vm._s(project.site_url)+"\n                      ")])]):_vm._e(),_vm._v(" "),_c('li',[(project.appstore_url != '' )?_c('a',{staticClass:"icon-link",attrs:{"target":"_blank","rel":"noopener","href":project.appstore_url}},[_c('i',{staticClass:"fa fa-2x fa-apple",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(project.playstore_url != '')?_c('a',{staticClass:"icon-link",attrs:{"target":"_blank","rel":"noopener","href":project.playstore_url}},[_c('i',{staticClass:"fa fa-2x fa-android",attrs:{"aria-hidden":"true"}})]):_vm._e()])])])])])])])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yqhT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "PreLoader"
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.7d56d5f95855bb8ce3a8.js